var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.388585 9.04193L5.45783 10.9045L7.41994 17.1166C7.54549 17.5145 8.03968 17.6616 8.3677 17.3976L11.1934 15.1298C11.4896 14.8922 11.9115 14.8804 12.221 15.1016L17.3175 18.7443C17.6684 18.9954 18.1656 18.8061 18.2536 18.3886L21.987 0.708909C22.0831 0.25293 21.628 -0.127462 21.187 0.0404622L0.382645 7.94147C-0.130762 8.1364 -0.126289 8.85199 0.388585 9.04193ZM7.10373 9.91303L17.0109 3.90596C17.189 3.79832 17.3722 4.03533 17.2193 4.17496L9.04296 11.6572C8.75556 11.9205 8.57018 12.273 8.51767 12.6555L8.23915 14.6875C8.20226 14.9588 7.81513 14.9858 7.73909 14.7232L6.66791 11.0178C6.54522 10.5952 6.72401 10.1438 7.10373 9.91303Z","fill":"white"}));
}

Telegram.defaultProps = {"width":"22","height":"19","viewBox":"0 0 22 19","fill":"none"};

module.exports = Telegram;

Telegram.default = Telegram;
